import React from 'react'

// Components
import Header from '../components/Header'
import Equipe from '../components/EquipeList'
import Footer from '../components/Footer'

const EquipePage = ({ data }) =>
  <div>
  <Header name="home-header site-header">
    <div className="container">
      <div className="grid-center">
         <div className="col-6_md-10 grid-column content center">
           <h1>
             Essa é a nossa equipe!
           </h1>
           <p>Conheça o perfil da galera que faz o Talkative funcionar.</p>
         </div>
      </div>
    </div>
  </Header>

  <Equipe />

  <Footer/>
  </div>

export default EquipePage



// WEBPACK FOOTER //
// ./src/pages/equipe.js